import React, { useEffect, useRef } from "react";
import styled from "styled-components";

const Container = styled.div`
  display: grid;
  grid-template-columns: minmax(50px, 1fr) minmax(50px, 2fr);
  margin: 0 1em;
`;

const CategoryTitle = styled.div`
  align-self: center;
  justify-self: end;
  padding-right: 1em;
`;

const Input = styled.input`
  background: var(--color-text-light);
  color: var(--color-text-dark);
  margin: 0.8em 0 0.8em 0;
  padding: 0.8em 1em;
  border-radius: 0.4em;
  border: 0em solid black;
  font-size: 1em;
  font-family: inherit;
  padding-bottom: 0.4em;
  line-height: 1.5em;
`;

interface CategoryProps {
  category: string;
  onChange: (category: string, input: string) => void;
  value: string;
  index: number;
  isShowing: boolean;
}

const Category = ({
  category,
  onChange,
  value,
  index,
  isShowing,
}: CategoryProps) => {
  const ref = useRef<HTMLInputElement>(null);
  useEffect(() => {
    if (index === 0) {
      ref.current?.focus();
    }
  }, [isShowing, index]);
  return (
    <Container>
      <CategoryTitle>{category}</CategoryTitle>
      <Input
        ref={ref}
        value={value}
        onChange={(e) => onChange(category, e.target.value)}
      />
    </Container>
  );
};
export default Category;
